import * as z from "zod/v4";

export const turnOnSupportDefaults = {
  name: "turnOnSupportDefaults" as const,
  input: z.object({ enableAI: z.boolean().optional() }),
  output: z.object({}),
};
